import { sum } from 'lodash';
import {
  IEdge,
  ILabel,
  INode,
  IRenderContext,
  LabelStyleBase,
  Rect,
  Size,
  Visual,
} from '@ardoq/yfiles';
import type { GraphItem, MultiLabelStyle } from '@ardoq/graph';
import {
  measureNodeLabel,
  MODERNIZED_BLOCK_DIAGRAM_FONT_SIZE as FONT_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';
import {
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_PADDING as PADDING,
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_VERTICAL_PADDING as VERTICAL_PADDING,
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABELS_VERTICAL_MARGIN as VERTICAL_MARGIN,
} from 'yfilesExtensions/styles/modernized/consts';
import { CanvasOtherLabelVisual } from './CanvasOtherLabelVisual';
import {
  calculateOtherLabelsLayout,
  otherLabelsTotalHeight,
  CANVAS_OTHER_LABELS_CONFIG,
} from '../shared/layoutUtils';

class CanvasOtherLabelStyle extends LabelStyleBase {
  constructor(private styles: MultiLabelStyle[]) {
    super();
  }
  protected override createVisual(
    _: IRenderContext,
    label: ILabel
  ): Visual | null {
    const {
      owner,
      tag,
      layout: { bounds },
    } = label;
    const wrapped = tag as string[][] | null;
    if (!wrapped) return null;

    const { tag: ownerTag } = owner as IEdge | INode;
    const { isTransparentized } = ownerTag as GraphItem;

    const rects = calculateOtherLabelsLayout(
      wrapped,
      CANVAS_OTHER_LABELS_CONFIG
    );

    const container = new Rect(
      bounds.x,
      bounds.y,
      bounds.width,
      otherLabelsTotalHeight(rects)
    );

    return new CanvasOtherLabelVisual(
      container,
      rects,
      wrapped,
      FONT_SIZE,
      LINE_HEIGHT,
      isTransparentized ? 0.32 : 1,
      this.styles
    );
  }

  protected override getPreferredSize(label: ILabel): Size {
    const { tag } = label;
    const wrappedOtherLabels = tag as string[][] | null;
    if (!wrappedOtherLabels) {
      return Size.ZERO;
    }
    const width =
      2 * PADDING +
      Math.max(
        ...wrappedOtherLabels.map(wrappedOtherLabel =>
          Math.max(...wrappedOtherLabel.map(measureNodeLabel))
        )
      );
    const height =
      sum(
        wrappedOtherLabels.map(
          wrappedOtherLabel =>
            wrappedOtherLabel.length * LINE_HEIGHT + 2 * VERTICAL_PADDING
        )
      ) +
      (wrappedOtherLabels.length - 1) * VERTICAL_MARGIN;
    return new Size(width, height);
  }
}
export { CanvasOtherLabelStyle };
